import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin'
import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin'
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { ListPlugin } from '@lexical/react/LexicalListPlugin'
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin'
import { HorizontalRulePlugin } from '@lexical/react/LexicalHorizontalRulePlugin'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import React, { useEffect } from 'react'
import { View } from 'styles/reactnative'
import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html'
import { $getRoot, $createParagraphNode, EditorState } from 'lexical'
import { editorConfig } from './editorConfig'
import ToolbarPlugin from './ToolbarPlugin'
import './styles.css'
import { TablePlugin } from '@lexical/react/LexicalTablePlugin'
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table'

function OnChangePlugin({ onChange }) {
	const [editor] = useLexicalComposerContext()
	useEffect(() => {
		return editor.registerUpdateListener(({ editorState }) => {
			editorState.read(() => {
				const html = $generateHtmlFromNodes(editor)
				onChange(html)
			})
		})
	}, [editor, onChange])
	return null
}

function LexicalErrorBoundary({ children }) {
	return <React.Fragment>{children}</React.Fragment>
}

const RichTextUpdateEditor = ({
	content,
	setContent,
	boxheight = 400,
	boxwidth = 900,
}) => {
	const initialConfig = {
		...editorConfig,
		nodes: [...editorConfig.nodes, TableCellNode, TableNode, TableRowNode],
		onError: (error) => console.error(error),
		editorState: (editor) => {
			const parser = new DOMParser()
			const dom = parser.parseFromString(content, 'text/html')
			editor.update(() => {
				const nodes = $generateNodesFromDOM(editor, dom)
				const root = $getRoot()
				if (nodes.length === 0) {
					const paragraph = $createParagraphNode()
					root.append(paragraph)
				} else {
					nodes.forEach(node => root.append(node))
				}
			})
		},
	}

	return (
		<View style={{ height: boxheight, width: '100%' }}>
			<LexicalComposer initialConfig={initialConfig}>
				<div className="editor-container" style={{ height: boxheight, width: boxwidth, background: '#f9f9f9' }}>
					<ToolbarPlugin />
					<RichTextPlugin
						contentEditable={<ContentEditable className="editor-input" />}
						placeholder={<div className="editor-placeholder">내용을 입력하세요...</div>}
						ErrorBoundary={LexicalErrorBoundary}
					/>
					<HistoryPlugin />
					<AutoFocusPlugin />
					<LinkPlugin />
					<ListPlugin />
					<HorizontalRulePlugin />
					<MarkdownShortcutPlugin />
					<TablePlugin />
					<OnChangePlugin onChange={setContent} />
				</div>
			</LexicalComposer>
		</View>
	)
}

export default RichTextUpdateEditor
